import React, { Component } from "react";
import { Image } from "components";

class ProjectDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentImg: props.mainUrl,
      currentImgSmall: props.mainUrlSmall,
      otherImgs: props.moreUrls,
    };

    this.handleClick = this.handleClick.bind(this);
  }
  componentWillMount() {
    document.body.scrollTop = 0;
  }

  renderDivider = () => {
    if (window.innerWidth <= 468 && this.props.moreUrls.length > 0) {
      return <h3 className="sans-serif">More Pics</h3>;
    }
  };

  swapImgs = (index) => {
    let { otherImgs, currentImg } = this.state;

    let newMain = otherImgs[index];
    let oldMain = currentImg;

    otherImgs[index] = oldMain;
    currentImg = newMain;

    this.setState({ currentImg: currentImg, otherImgs: otherImgs });
  };

  handleClick = (id) => {
    this.swapImgs(id);
  };

  render() {
    const transition = "fade-in";
    let { projectName, location, size, description } = this.props;

    if (this.state.otherImgs.length === 0) {
      return (
        <div
          className={transition}
          style={{ paddingTop: "2em", minHeight: "87vh" }}
        >
          <div className="row">
            <div className="col-xs-12 col-sm-8 col-sm-offset-2">
              <Image
                alt=""
                src={this.state.currentImg}
                srcSmall={this.state.currentImgSmall}
                style={{ maxWidth: "100%" }}
              />
              <h2 className="body">{projectName}</h2>
              <h3 className="body m-t-0 m-b-0">{location}</h3>
              <h3 className="body m-t-0">{size || ""}</h3>
              <p className="body weight-300">{description}</p>
              {this.renderDivider()}
            </div>
          </div>
        </div>
      );
    }

    return (
      <div
        className={transition}
        style={{ paddingTop: "2em", minHeight: "80vh" }}
      >
        <div className="row">
          <div className="col-xs-12 col-sm-9">
            <Image
              alt=""
              src={this.state.currentImg}
              srcSmall={this.state.currentImgSmall}
              style={{ maxWidth: "100%" }}
            />
            <h2 className="body">{projectName}</h2>
            <h3 className="body m-t-0 m-b-0">{location}</h3>
            <h3 className="body m-t-0">{size}</h3>
            <p className="body weight-300">{description}</p>
            {this.renderDivider()}
          </div>
          <div className="col-xs-12 col-sm-3">
            {this.state.otherImgs.map((curr, i) => (
              <img
                onClick={
                  window.innerWidth > 468 ? (e) => this.handleClick(i, e) : null
                }
                alt=""
                src={curr}
                className={window.innerWidth < 468 ? "" : "box-shadow"}
                style={{ maxWidth: "100%", marginBottom: "1em" }}
                key={i}
                id={i}
              />
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default ProjectDetails;



// WEBPACK FOOTER //
// ./src/components/ProjectDetails.jsx